function withQuery(url, params) {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, value]) => Boolean(value)),
    ).toString();

    return query ? `${url}?${query}` : url;
}

export function trackAndTraceUrl(traceUuid, { goodId, fromOrderId } = {}) {
    return withQuery(`/track-and-trace/${traceUuid}`, { good: goodId, from_order: fromOrderId });
}

export function trackAndTraceDeliveryPreferencesUrl(traceUuid, { fromOrderId } = {}) {
    return withQuery(`/track-and-trace/${traceUuid}/delivery-preferences`, { from_order: fromOrderId });
}
